import { css, keyframes } from 'styled-components'

const pulse = keyframes`
  0%{
    transform: scale(1);
  }
  
  25% {
    transform: scale(.75);
  }
  
  50% {
    transform: scale(1);
  }
  
  75% {
    transform: scale(.75);
  }
  
  100% {
    transform: scale(1);
  }
`

export const pulseAnimation = css`
  animation: ${pulse} 2s infinite;
  animation-timing-function: ease-in-out;
`

export const size = 19
